export const ADDRESS_FORM_NAME = 'address';
export const ADDRESS_TYPE_SHIPPING = 'shipping';
export const ADDRESS_FORM_SUCCESS = 'SUCCESS';
